import { PlusOutlined, ReloadOutlined } from '@ant-design/icons'
import { getOperationName } from '@apollo/client/utilities'
import { Button, Input, Tag, Tooltip } from 'antd'
import React from 'react'

import {
  GetViewerJournalProjectsDocument,
  useCreateJournalProjectMutation,
  useDeleteJournalProjectMutation,
  useGetViewerQuery,
} from '@/generated/graphql'

import s from './post-editor.module.less'
import { PostEditorSetState, journalTemplate } from './post-editor.state'

interface PostEditorJournalProjectsProps {
  setState: PostEditorSetState
  projects: string[]
}

export const PostEditorJournalProjects: React.FC<PostEditorJournalProjectsProps> = ({ projects, setState }) => {
  const [input, setInput] = React.useState('')
  const { data } = useGetViewerQuery()

  const refetchQueries = {
    refetchQueries: [getOperationName(GetViewerJournalProjectsDocument)!],
  }

  const [createProject] = useCreateJournalProjectMutation({
    ...refetchQueries,
  })
  const [deleteProject] = useDeleteJournalProjectMutation({
    ...refetchQueries,
  })

  if (!data) {
    return null
  }
  const isValid = () => {
    if (projects.length < 5 && input !== '' && !projects.includes(input)) {
      return true
    }
    return false
  }

  return (
    <div className={s.projects}>
      <div className={s.input}>
        <Input
          allowClear
          placeholder='添加长期项目, 最多 5 个'
          value={input}
          maxLength={50}
          onChange={(e) => setInput(e.target.value)}
        />
        <Tooltip title='添加长期项目'>
          <Button
            className={s.button}
            icon={<PlusOutlined />}
            disabled={!isValid()}
            onClick={() => {
              createProject({ variables: { userId: data.viewer.userId, project: input } })
              setInput('')
            }}
          />
        </Tooltip>
        <Tooltip title='更新模版'>
          <Button
            className={s.button}
            icon={<ReloadOutlined />}
            onClick={() => setState((state) => ({ ...state!, content: journalTemplate(projects) }))}
          />
        </Tooltip>
      </div>
      <div className={s.display}>
        <span>长期项目：{projects.length === 0 && '无'}</span>
        {projects.map((project) => (
          <Tag
            color='blue'
            key={project}
            closable
            onClose={() => {
              deleteProject({
                variables: {
                  userId: data.viewer.userId,
                  project,
                },
              })
            }}
          >
            {project}
          </Tag>
        ))}
      </div>
    </div>
  )
}
